module.exports = __webpack_public_path__ + "img/gmail-icon.2ea36153.svg";